import api from '@/lib/axios'

export interface LocalizedString {
    tr: string
    en?: string
    fr?: string
    es?: string
    ru?: string
    nl?: string
    ar?: string
}

export interface GlobalMapStat {
    value: string
    label: LocalizedString
}

export interface GlobalMapData {
    badge: LocalizedString
    title1: LocalizedString
    title2: LocalizedString
    body: LocalizedString
    regionsText: LocalizedString
    logisticsSupportText: LocalizedString
    mapImage: string
    stats: GlobalMapStat[]
}

export const globalMapService = {
    getGlobalMap: async (): Promise<GlobalMapData> => {
        const response = await api.get('/global-map/raw')
        return response.data
    },

    updateGlobalMap: async (data: Partial<GlobalMapData>): Promise<GlobalMapData> => {
        const response = await api.put('/global-map', data)
        return response.data
    },
}
